<template>
    <h1 class="main-title">
    {{titleText}}
  </h1>
</template>

<script>
export default {
    name: 'GameTitle',
    props: {
        titleText: String
    }    
}
</script>

<style>
    
</style>